// import { Grid, InputBase, Typography } from '@mui/material';
import { Grid, Typography } from '@mui/material';

export const Comment = () => {
  return (
    <Grid display="grid" gap="10px">
      <Typography fontWeight="bold">Комментарий</Typography>
      {/*<InputBase id={'constructor_comment'} rows={4} multiline autoFocus={false} tabIndex={-1} />*/}
      <textarea id={'constructor_comment'} rows={6} autoFocus={false} tabIndex={-1} />
    </Grid>
  );
};
